import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

export enum TypeMessage {
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning'
}

@Injectable()
export class NotificationService {

    constructor() { }
    displayMessage(type: TypeMessage, message: string, displayTime: number = 5000) {
        notify(message, type.toString(), displayTime);
    }
}
